//@ts-check
import {ProductReviewHeader} from './components/ProductReviewHeader'
import {ProductReviewTabs} from './components/ProductReviewTabs/ProductReviewTabs'

export const ProductReview = () => {
  return (
    <div className="flex flex-col gap-6 pb-8">
      <ProductReviewHeader />
      <ProductReviewTabs />
    </div>
  )
}
